if (!customElements.get("cart-shipping-rate-information")) {
  customElements.define(
    "cart-shipping-rate-information",
    class CartShippingRateInformation extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {
        this.setVariables();
        this.setEvents();
        this.init(this.orderAttributes.cartAttributes);
      }

      setVariables() {
        this.shippingAreas = window.shopVariables.shippingAreas;
        this.orderAttributes = document.querySelector('order-attributes');
        this.shippingText = this.getAttribute('data-shipping-text');
        this.dynamicRate = this.getAttribute('data-dynamic-rate');
        this.shippingPriceValueElement = this.querySelector('.cart__shipping-rate-information-value');
        this.shippingPriceValue = this.shippingText;
        this.cartAttributeZipCode = '';
        this.cartTotalPriceElement = document.querySelector('[data-cart-total-price]');
      }

      setEvents() {
        document.addEventListener('cart-attributes:updated', (event) => {
          this.init(event.detail.cartAttributes);
        });

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          setTimeout(() => {
            this.init(this.orderAttributes.cartAttributes);
          }, 1500);
        });
      }

      init(cartAttributes) {
        if (!cartAttributes || this.shippingPriceValueElement === null) return;

        this.cartAttributeZipCode = cartAttributes['zipcode'] || '';

        if (this.dynamicRate == 'true' && this.cartAttributeZipCode !== undefined && this.cartAttributeZipCode !== '') {
            this.shippingPriceValue = this.formatShippingPrice(this.shippingPrice.rateExcludingTaxes);
        }

        this.shippingPriceValueElement.textContent = this.shippingPriceValue;

        if (this.cartTotalPriceElement) {
          let cartTotalPrice = parseInt(this.cartTotalPriceElement.dataset.cartTotalPrice);
          let shippingPriceIncludingTaxes = this.getShippingPriceCents(this.shippingPrice.rateIncludingTaxes);
          let newCartTotalPrice = cartTotalPrice + shippingPriceIncludingTaxes;

          this.cartTotalPriceElement.textContent = formatPrice(newCartTotalPrice);
        }
      }

      get shippingPrice() {
        let resultExcludingTaxes = '';
        let resultIncludingTaxes = '';
        let zipCode = this.cartAttributeZipCode;

        if (zipCode === undefined || zipCode === '') return result;

        if (this.shippingAreas.area1.zipCodes.indexOf(zipCode) != -1) {
            resultExcludingTaxes = this.shippingAreas.area1.rateExcludingTaxes;
            resultIncludingTaxes = this.shippingAreas.area1.rateIncludingTaxes;
        } else if (this.shippingAreas.area2.zipCodes.indexOf(zipCode) != -1) {
            resultExcludingTaxes = this.shippingAreas.area2.rateExcludingTaxes;
            resultIncludingTaxes = this.shippingAreas.area2.rateIncludingTaxes;
        } else if (this.shippingAreas.area3.zipCodes.indexOf(zipCode) != -1) {
            resultExcludingTaxes = this.shippingAreas.area3.rateExcludingTaxes;
            resultIncludingTaxes = this.shippingAreas.area3.rateIncludingTaxes;
        } else if (this.shippingAreas.area4.zipCodes.indexOf(zipCode) != -1) {
            resultExcludingTaxes = this.shippingAreas.area4.rateExcludingTaxes;
            resultIncludingTaxes = this.shippingAreas.area4.rateIncludingTaxes;
        }

        return {
            rateExcludingTaxes: resultExcludingTaxes,
            rateIncludingTaxes: resultIncludingTaxes,
        };
      }

      getShippingPriceCents(price) {
        let priceParsable = price.replace(',', '');
        let cents = parseInt(priceParsable);

        return cents;
      }

      formatShippingPrice(price) {
        let cents = this.getShippingPriceCents(price);

        return formatPrice(cents);
      }
    }
  );
}